import { ReactElement } from "react";
import Navbar from "../../components/Navbar/Navbar";
import ContactList from "../../components/ContactList/ContactList";
import { useContact } from "./Contact.logic";
import AppLoader from "../../components/AppLoader/AppLoader";
import PremiumBanner from "../../components/PremiumBanner/PremiumBanner";
import FlexWrapper from "../../components/FlexWrapper/FlexWrapper";
import { Flex, Loader, Text } from "@fluentui/react-northstar";
import { CookiesDialog, ErrorBanner, Modal, OnboardingTour, PersistentAlert, useModalSelector, useMsTeamsSelector, useTranslate } from "front";
import { translations } from "../../translations";
import { ONBOARDING_TOUR_APP_KEY, ONBOARDING_TOUR_CTA_TARGET, ONBOARDING_TOUR_STEPS } from "../../const/OnboardingTour.steps";
import "./Contact.scss";

export const Contact = (): ReactElement | null => {
  const logic = useContact();
  const t = useTranslate(translations);
  const { isOpen } = useModalSelector("isOpen");

  if (logic.error)
    return (
      <FlexWrapper>
        <Text content={t("DefaultError")} />
      </FlexWrapper>
    );

  if (logic.permsAreLoading) return <AppLoader />;

  const renderPersistantAlert = () => {
    return <PersistentAlert />;
  };

  const renderCookiesDialog = () => {
    if (isOpen != Modal.COOKIES && isOpen != Modal.COOKIES_ON_START) return;
    return <CookiesDialog isOpenedOnStart={isOpen == Modal.COOKIES_ON_START} />;
  };

  return (
    <>
      {logic.isLoading && <AppLoader />}
      <div className="contact-top-container">
        <PremiumBanner />
        <Navbar />
        {renderPersistantAlert()}
        {renderCookiesDialog()}
      </div>
      <Flex className="contact-bottom-container" data-is-premium={logic.isPremium}>
        {logic.contactAreLoading ? (
          <Flex fill className="contact-contact-loader" vAlign="center" hAlign="center">
            <Loader />
          </Flex>
        ) : (
          <ContactList />
        )}
      </Flex>
      <OnboardingTour
        appKey={ONBOARDING_TOUR_APP_KEY}
        steps={ONBOARDING_TOUR_STEPS}
        t={t}
        isReady={logic.isTourReady}
        cta={{ labelKey: "OnboardingTour:CreateFirstContact", target: ONBOARDING_TOUR_CTA_TARGET, onClick: logic.createNewContact }}
      />
    </>
  );
};
